document.addEventListener("DOMContentLoaded", () => {
  "use strict";

  // LOADING

  const backgroundOverlay = document.getElementById("background-overlay");
  const mainContent = document.getElementById("content");
  const circle = document.querySelector("circle.progressRingCircle");
  const loadingBlock = document.getElementById("loading-block"); // عنصر اللودينج

  const radius = circle.r.baseVal.value;
  const circumference = 2 * Math.PI * radius;

  circle.style.strokeDasharray = `${circumference}`;
  circle.style.strokeDashoffset = `${circumference}`;

  let progress = 0;
  let typedStarted = false;

  const loadingInterval = setInterval(() => {
    progress += 1; // زيادة النسبة تدريجيًا
    const offset = circumference - (progress / 100) * circumference;
    circle.style.strokeDashoffset = offset;

    if (progress >= 95 && !typedStarted) {
      const typedElement = document.querySelector("#typed"); // تحقق من وجود العنصر
      if (typedElement) {
        typedStarted = true;
        const pathParts = window.location.pathname.split("/");
        const langCode = pathParts[1] || "ar";
        const strings = langCode == "ar" ? ["مبتكر", "مميز", "حديث"] : ["Innovative", "Special", "Modern"];

        const options = {
          strings,
          typeSpeed: 0,
          backSpeed: 0,
          startDelay: 0,
          backDelay: 1500,
          fadeOut: true,
          showCursor: false,
          shuffle: false,
          loop: true,
        };

        new Typed("#typed", options); // تفعيل مكتبة Typed.js هنا
      }
    }

    if (progress >= 100) {
      clearInterval(loadingInterval);

      backgroundOverlay.style.opacity = 0;
      backgroundOverlay.style.visibility = "hidden";

      loadingBlock.classList.add("loaded");

      setTimeout(() => {
        mainContent.style.visibility = "visible";
        mainContent.style.opacity = 1;

        setTimeout(() => {
          loadingBlock.style.position = "absolute";
        }, 450);

        setTimeout(() => {
          AOS.init({
            once: true,
          });
        }, 100);
      }, 200);
    }
  }, 14); // التحكم بسرعة التحميل

  //-LINKS
  // الحصول على جميع روابط التنقل
  const navLinks = document.querySelectorAll(".navbar-nav .nav-link");

  // الحصول على اسم الصفحة الحالية
  const currentPath = window.location.pathname.split("/").pop() || "index.html";

  navLinks.forEach((link) => {
    const linkPath = link.getAttribute("href");

    // التحقق إذا كان الرابط يبدأ بـ #
    if (linkPath && linkPath.startsWith("#")) {
      link.addEventListener("click", (event) => {
        event.preventDefault(); // منع السلوك الافتراضي

        if (currentPath === "index.html") {
          // إذا كنت في الصفحة الرئيسية، انتقل مباشرةً إلى القسم
          const sectionId = linkPath.slice(1); // إزالة #
          const section = document.getElementById(sectionId);

          if (section) {
            section.scrollIntoView({ behavior: "smooth" });

            // إزالة الكلاس 'active' من كل الروابط
            navLinks.forEach((navLink) => navLink.classList.remove("active"));

            // إضافة الكلاس 'active' للرابط الحالي
            link.classList.add("active");
          }
        } else {
          // إذا كنت في صفحة أخرى، انتقل إلى الصفحة الرئيسية مع الرابط
          window.location.href = `index.html${linkPath}`;
        }
      });
    } else {
      // التحقق من الروابط العادية ومقارنتها مع الصفحة الحالية
      if (linkPath === currentPath) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    }
  });

  //-SCROLLSPY
  document.querySelectorAll("a.scrollSpy").forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
      e.preventDefault();
      const targetId = this.getAttribute("href").substring(1); // استخراج الـ id
      const targetElement = document.getElementById(targetId); // تحديد العنصر المستهدف

      targetElement.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  });

  // AUTO SCROLL
  if (document.querySelector(".splideAutoScroll")) {
    const splide = new Splide(".splideAutoScroll", {
      direction: "ltr",
      type: "loop",
      drag: "free",
      focus: "center",
      perPage: 5,
      pagination: false,
      arrows: false,
      autoScroll: {
        speed: 1.2,
      },
      breakpoints: {
        1024: { perPage: 3 },
        768: { perPage: 2 },
        480: { perPage: 2 },
      },
    });
    splide.mount(window.splide.Extensions);
  }

  // SPLIDE SWIPER
  if (document.querySelector(".splideSwiper")) {
    const splideSwiper = new Splide(".splideSwiper", {
      direction: "ltr",
      autoplay: true,
      interval: 3000,
      type: "loop",
    });
    splideSwiper.mount();
  }

  // TEXTAREA AUTO RESIZE
  const textarea = document.getElementById("auto-resize-textarea");
  if (textarea) {
    textarea.addEventListener("input", function () {
      this.style.height = "auto"; // إعادة تعيين الارتفاع
      this.style.height = `${this.scrollHeight}px`; // تمديد بناءً على المحتوى

      if (this.scrollHeight >= parseInt(this.style.maxHeight)) {
        this.style.overflowY = "auto";
      } else {
        this.style.overflowY = "hidden";
      }
    });
  }

  // MODAL IFRAME CONTROL
  const modal = document.getElementById("playViddeo");
  const iframe = document.getElementById("projectVideo");

  if (modal && iframe) {
    modal.addEventListener("shown.bs.modal", () => {
      iframe.src += "&autoplay=1"; // تشغيل الفيديو تلقائيًا
    });

    modal.addEventListener("hidden.bs.modal", () => {
      iframe.src = iframe.src.replace("&autoplay=1", ""); // إيقاف الفيديو
    });
  }

  // -UPLOAD FILE
  const fileInput = document.getElementById("formFile");
  const fileList = document.getElementById("fileList");
  const uploadButton = document.querySelector(".btn-uploadFile");

  // تحقق من وجود العناصر قبل تنفيذ الكود
  if (fileInput && fileList && uploadButton) {
    const maxFiles = 3;
    const maxFileSize = 5 * 1024 * 1024; // الحد الأقصى للحجم (5 ميغابايت)
    const allowedExtensions = ["pdf", "doc", "docx", "txt"]; // الامتدادات المقبولة

    fileInput.addEventListener("change", () => {
      const files = Array.from(fileInput.files);

      files.forEach((file) => {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileSize = file.size;

        // تحقق من الامتداد
        if (!allowedExtensions.includes(fileExtension)) {
          alert(`نوع الملف غير مدعوم: ${file.name}`);
          return;
        }

        // تحقق من الحجم
        if (fileSize > maxFileSize) {
          const largeFileWarning = document.createElement("span");
          largeFileWarning.textContent = `حجم الملف ${file.name} كبير جدًا`;
          largeFileWarning.classList.add("error-message");
          fileList.appendChild(largeFileWarning);
          return;
        }

        // تحقق من الحد الأقصى للملفات
        if (fileList.children.length < maxFiles) {
          const listItem = document.createElement("li");
          listItem.classList.add("file-item");

          const fileName = document.createElement("span");
          fileName.textContent = file.name;

          const removeButton = document.createElement("button");

          removeButton.classList.add("btn", "btn-remove-file");

          removeButton.addEventListener("click", () => {
            listItem.remove();

            // تمكين زر الرفع عند حذف ملف
            if (fileList.children.length < maxFiles) {
              uploadButton.classList.remove("disabled");
              uploadButton.disabled = false;
            }
          });

          listItem.appendChild(fileName);
          listItem.appendChild(removeButton);
          fileList.appendChild(listItem);
        }
      });

      // تعطيل زر الرفع إذا وصل الحد الأقصى
      if (fileList.children.length >= maxFiles) {
        uploadButton.classList.add("disabled");
        uploadButton.disabled = true;
      }

      // Clear file input to allow re-uploading the same file
      fileInput.value = "";
    });
  }
});
